<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="contents"></a>
<a id="page_vii"></a>
<h2 class="title2">CONTENTS</h2>
<p class="toc-chapter" id="toc_p1">
<a href="#/intro">Introduction</a>
</p>
<p class="toc-chapter" id="toc_p2">
<span href="#/preface" title="Link target outside of Sample">Note to the Paperback Edition</span>
</p>
<p class="toc-chapter" id="toc_p3">
<span href="#/chap1#chap1_p1b" title="Link target outside of Sample">I. We begin first of all by speaking of the Lion</span>
</p>
<p class="toc-chapter" id="toc_p4">
<span href="#/chap1#chap1_p4" title="Link target outside of Sample">II. On the Antelope</span>
</p>
<p class="toc-chapter" id="toc_p5">
<span href="#/chap1#chap1_p7" title="Link target outside of Sample">III. On Piroboli Rocks</span>
</p>
<p class="toc-chapter" id="toc_p6">
<span href="#/chap1#chap1_p10" title="Link target outside of Sample">IV. On the Swordfish</span>
</p>
<p class="toc-chapter" id="toc_p7">
<span href="#/chap1#chap1_p13" title="Link target outside of Sample">V. On the Charadrius</span>
</p>
<p class="toc-chapter" id="toc_p8">
<span href="#/chap1#chap1_p17" title="Link target outside of Sample">VI. On the Pelican</span>
</p>
<p class="toc-chapter" id="toc_p9">
<span href="#/chap1#chap1_p20" title="Link target outside of Sample">VII. On the Owl</span>
</p>
<p class="toc-chapter" id="toc_p10">
<span href="#/chap1#chap1_p24" title="Link target outside of Sample">VIII. On the Eagle</span>
</p>
<p class="toc-chapter" id="toc_p11">
<span href="#/chap1#chap1_p27" title="Link target outside of Sample">IX. On the Phoenix</span>
</p>
<p class="toc-chapter" id="toc_p12">
<span href="#/chap1#chap1_p32" title="Link target outside of Sample">X. On the Hoopoe</span>
</p>
<p class="toc-chapter" id="toc_p13">
<span href="#/chap1#chap1_p33" title="Link target outside of Sample">XI. On the Wild Ass</span>
</p>
<p class="toc-chapter" id="toc_p14">
<span href="#/chap1#chap1_p36" title="Link target outside of Sample">XII. On the Viper</span>
</p>
<p class="toc-chapter" id="toc_p15">
<span href="#/chap1#chap1_p39" title="Link target outside of Sample">XIII. On the Serpent</span>
</p>
<p class="toc-chapter" id="toc_p16">
<span href="#/chap1#chap1_p44" title="Link target outside of Sample">XIV. On the Ant</span>
</p>
<p class="toc-chapter" id="toc_p17">
<span href="#/chap1#chap1_p49" title="Link target outside of Sample">XV. On the Siren and Ass-Centaur</span>
</p>
<p class="toc-chapter" id="toc_p18">
<span href="#/chap1#chap1_p53" title="Link target outside of Sample">XVI. On the Hedgehog</span>
</p>
<p class="toc-chapter" id="toc_p19">
<span href="#/chap1#chap1_p57" title="Link target outside of Sample">XVII. On the Ibis</span>
</p>
<p class="toc-chapter" id="toc_p20">
<span href="#/chap1#chap1_p62" title="Link target outside of Sample">XVIII. On the Fox</span>
</p>
<p class="toc-chapter" id="toc_p21">
<span href="#/chap1#chap1_p65" title="Link target outside of Sample">XIX. On the Peridexion Tree and the Doves</span>
</p>
<p class="toc-chapter" id="toc_p22">
<span href="#/chap1#chap1_p70" title="Link target outside of Sample">XX. On the Elephant</span>
</p>
<p class="toc-chapter" id="toc_p23">
<span href="#/chap1#chap1_p74" title="Link target outside of Sample">XI. On Amos the Prophet</span>
</p>
<p class="toc-chapter" id="toc_p24">
<span href="#/chap1#chap1_p76" title="Link target outside of Sample">XXII. On the Roe</span>
</p>
<p class="toc-chapter" id="toc_p25">
<span href="#/chap1#chap1_p80" title="Link target outside of Sample">XXIII. On the Agate-stone</span>
</p>
<p class="toc-chapter" id="toc_p26">
<span href="#/chap1#chap1_p82" title="Link target outside of Sample">XXIV. On the Oyster-stone and the Pearl</span>
</p>
<p class="toc-chapter" id="toc_p27">
<span href="#/chap1#chap1_p89" title="Link target outside of Sample">XXV. On the Adamant-stone</span>
</p>
<p class="toc-chapter" id="toc_p28">
<span href="#/chap1#chap1_p92" title="Link target outside of Sample">XXVI. On the Other Nature of the Wild Ass and the Monkey</span>
</p>
<p class="toc-chapter" id="toc_p29">
<span href="#/chap1#chap1_p96" title="Link target outside of Sample">XXVII. On the Indian-stone</span>
</p>
<p class="toc-chapter" id="toc_p30">
<span href="#/chap1#chap1_p99" title="Link target outside of Sample">XXVIII. On the Heron, that is, the Coot</span>
</p>
<p class="toc-chapter" id="toc_p31">
<span href="#/chap1#chap1_p102" title="Link target outside of Sample">XXIX. On the Fig Tree</span>
</p>
<p class="toc-chapter" id="toc_p32">
<span href="#/chap1#chap1_p105" title="Link target outside of Sample">XXX. On the Panther</span>
</p>
<p class="toc-chapter" id="toc_p33">
<span href="#/chap1#chap1_p114" title="Link target outside of Sample">XXXI. On the Whale, that is, the Aspidoceleon</span>
</p>
<a id="page_viii"></a>
<p class="toc-chapter" id="toc_p34">
<span href="#/chap1#chap1_p117" title="Link target outside of Sample">XXXII. On the Partridge</span>
</p>
<p class="toc-chapter" id="toc_p35">
<span href="#/chap1#chap1_p120" title="Link target outside of Sample">XXXIII. On the Vulture</span>
</p>
<p class="toc-chapter" id="toc_p36">
<span href="#/chap1#chap1_p124" title="Link target outside of Sample">XXXIV. On the Ant-lion</span>
</p>
<p class="toc-chapter" id="toc_p37">
<span href="#/chap1#chap1_p127" title="Link target outside of Sample">XXXV. On the Weasel</span>
</p>
<p class="toc-chapter" id="toc_p38">
<span href="#/chap1#chap1_p132" title="Link target outside of Sample">XXXVI. On the Unicorn</span>
</p>
<p class="toc-chapter" id="toc_p39">
<span href="#/chap1#chap1_p136" title="Link target outside of Sample">XXXVII. On the Beaver</span>
</p>
<p class="toc-chapter" id="toc_p40">
<span href="#/chap1#chap1_p139" title="Link target outside of Sample">XXXVIII. On the Hyena or the Brute</span>
</p>
<p class="toc-chapter" id="toc_p41">
<span href="#/chap1#chap1_p142" title="Link target outside of Sample">XXXIX. On the Niluus</span>
</p>
<p class="toc-chapter" id="toc_p42">
<span href="#/chap1#chap1_p145" title="Link target outside of Sample">XL. On the Echinemon</span>
</p>
<p class="toc-chapter" id="toc_p43">
<span href="#/chap1#chap1_p148" title="Link target outside of Sample">XLI. On the Little Crow</span>
</p>
<p class="toc-chapter" id="toc_p44">
<span href="#/chap1#chap1_p151" title="Link target outside of Sample">XLII. On the Ostrich</span>
</p>
<p class="toc-chapter" id="toc_p45">
<span href="#/chap1#chap1_p154" title="Link target outside of Sample">XLIII. On the Turtle-dove</span>
</p>
<p class="toc-chapter" id="toc_p46">
<span href="#/chap1#chap1_p159" title="Link target outside of Sample">XLIV. On the Swallow</span>
</p>
<p class="toc-chapter" id="toc_p47">
<span href="#/chap1#chap1_p162" title="Link target outside of Sample">XLV. On the Stag</span>
</p>
<p class="toc-chapter" id="toc_p48">
<span href="#/chap1#chap1_p167" title="Link target outside of Sample">XLVI. On the Frog</span>
</p>
<p class="toc-chapter" id="toc_p49">
<span href="#/chap1#chap1_p170" title="Link target outside of Sample">XLVII. On the Lizard, that is, the Salamander</span>
</p>
<p class="toc-chapter" id="toc_p50">
<span href="#/chap1#chap1_p173" title="Link target outside of Sample">XLVIII. On the Magnet</span>
</p>
<p class="toc-chapter" id="toc_p51">
<span href="#/chap1#chap1_p175" title="Link target outside of Sample">XLIX. On the Adamant-stone</span>
</p>
<p class="toc-chapter" id="toc_p52">
<span href="#/chap1#chap1_p182" title="Link target outside of Sample">L. On the Doves</span>
</p>
<p class="toc-chapter" id="toc_p53">
<span href="#/chap1#chap1_p189" title="Link target outside of Sample">LI. On the Sun-lizard, that is, the Sun-eel</span>
</p>
<p class="toc-chapter" id="toc_p54">
<span href="#/notes" title="Link target outside of Sample">Notes</span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5dac2654